import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { StorageService } from "src/app/services/storage.service";
import * as moment from "moment";

@Component({
  selector: "fury-claim-prioritization-modal",
  templateUrl: "./claim-prioritization-modal.component.html",
  styleUrls: ["./claim-prioritization-modal.component.scss"],
})
export class ClaimPrioritizationModalComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject();
  PriorityValue = ["Normal", "Emergency"];
  claimPrioritizationForm = new FormGroup({
    priority: new FormControl("Normal"),
    dueDate: new FormControl(""),
  });
  maxDate = new Date();
  isLoading = false;
  agentId: string = this.storageService.getUser()?.userId;
  constructor(
    public dialogRef: MatDialogRef<ClaimPrioritizationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private storageService: StorageService
  ) {}

  ngOnInit(): void {
    if(this.data){
      this.claimPrioritizationForm.setValue({
        priority: this.data?.priority,
        dueDate: this.data?.dueDate? new Date(this.data?.dueDate) as any : null
      })
    }
    
  }

  onNoClick() {
    this.dialogRef.close();
  }
  clearDate() {
    this.claimPrioritizationForm.get("dueDate").setValue("");
  }
  changeClaimPriority() {
    if (this.claimPrioritizationForm.valid) {
      this.isLoading = true;
      const payload: any = {
        agentId: this.agentId,
        priority: this.claimPrioritizationForm.value.priority,
        dueDate: this.claimPrioritizationForm.value.dueDate
          ? moment(this.claimPrioritizationForm.value.dueDate).format(
              "YYYY-MM-DD"
            )
          : null,
      };
      this.apiService
        .patch(
          endpoints.fileAClaim.changeClaimPriority(this.data?.fileClaimId),
          payload
        )
        .pipe(
          finalize(() => (this.isLoading = false)),
          takeUntil(this.ngUnsubscribe)
        )
        .subscribe({
          next: (response: HttpResponse<any>) => {
            if (response.body) {
              this.apiService.alert(response.body?.message, ErrorType.Success);
              this.dialogRef.close(true);
            }
          },
          error: (error: HttpErrorResponse) => {
            this.apiService.alert(error.message, ErrorType.Error);
          },
        });
    } else {
      this.claimPrioritizationForm.markAllAsTouched();
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
